module.exports = __webpack_public_path__ + "static/img/first-bg-kaka.a2b6fd12.png";